import ApplicationWorkspace from "@/components/pages/ApplicationWorkspace.tsx";
import DashboardLayout from "@/layout/DashboardLayout.tsx";

export default function ApplicationWorkspaceView() {
    return (
        <DashboardLayout>
            <ApplicationWorkspace/>
        </DashboardLayout>
    );
}
